<template>
   <div>

     <!-- div for color and size  -->
     <div>
        <!-- div for color  -->
        <div class="mb-4 ">
            <p class="my-2 text-gray-700 public-text">رنگ :</p>
            <div  class="border h-8 w-full lg:w-1/2 relative shadow-md rounded-md" ref="colorDropDown">

                 <div class="flex items-center h-full justify-between px-2 cursor-pointer hover:bg-gray-100  public-text text-gray-600 hover: text-gray-700" @click="colorList = !colorList" >
                     <span v-if="color.length === 1"> {{ color[0] }}</span>
                      <span v-else> {{ colorValue }}</span>
                      <FontAwesomeIcon :icon="['fas', 'chevron-down']" class="transition-transform duration-150" :class=" colorList && color.length !== 1 ? 'rotate-180' : '' "/>
                 </div>

                 <!-- selectBox for color  -->
                 <ul v-if="color.length !== 1" class="absolute top-8 right-0 bg-white w-full transition-all duration-150 rounded shadow overflow-hidden " :class="!colorList ? 'h-0 ' : ' shadow-md z-10'">

                   <li v-if="!color.length" class="px-2 my-2 cursor-pointer hover:text-gray-700 public-text text-gray-600 transition-all duration-150 ">
                     درحال پردازش داده ها ...
                   </li>

                   <li v-else class="px-2 mb-[2px] public-text text-gray-600 hover:text-gray-700 flex items-center cursor-pointer hover:bg-gray-100 transition-all duration-150 h-6 last:mb-0" @click="
                       colorValue = item;
                       colorList = false;
                       colorIndex = index;
                       la = item;
                       ba='';
                       qtyProduct=0;
                       sizeValue = 'سایز را انتخاب کنید';
                     "
                     v-for="(item, index) in color"
                     :key="index">
                     {{ item }}
                   </li>

              </ul>
            </div>
        </div>

         <!-- div for size  -->
         <div  class="mb-4 ">
            <p class="my-2 text-gray-700 public-text">سایز :</p>

            <div class="border h-8 w-full lg:w-1/2 relative shadow-md rounded-md" ref="sizsDropDown" >
              <div class="flex items-center h-full justify-between px-2 cursor-pointer public-text text-gray-600 hover: text-gray-700 hover:bg-gray-100" @click="sizeList = !sizeList">
                 <span> {{ sizeValue }}</span>
                 <FontAwesomeIcon icon="chevron-down" class="transition-transform duration-150" :class="sizeList ? 'rotate-180' : ''"/>
              </div>

              <!-- selectBox for size  -->
              <ul class="absolute top-8 right-0 bg-white w-full transition-all duration-150  overflow-hidden "
                :class="!sizeList ? 'h-0 ' : ' shadow-md'" >

                <li v-if="!la" class="px-2 my-2 cursor-pointer hover:text-gray-700 public-text text-gray-600 transition-all duration-150 ">
                  ابتدا رنگ را انتخاب کنید ...
                </li>

                <li v-else class="px-2 h-6 mb-[2px] nth-last:mb-0  cursor-pointer public-text text-gray-600 hover:text-gray-700 hover:bg-gray-100 transition-all duration-150 flex items-center justify-between last:mb-0" v-for="(item, index) in size[colorIndex]"
                  :key="index"
                  @click="
                    sizeValue = item.size;
                    sizeList = false;
                    ba = item.size;
                    qtyProduct = item.qty;
                  ">

                  <span>{{ item.size }}</span>
                  <span v-if="item.qty">{{ digitsEnToFa(item.qty) }}</span>
                  <span v-else>{{ digitsEnToFa('0') }}</span>
                </li>

              </ul>
            </div>
          </div>

            <!-- div for entity -->
          <div class="h-10 flex items-center my-2 public-text">
             <div v-if="la && ba">
                <div v-if="showQty && showQtyProduct" class="flex items-center color-gray-500">
                  <FontAwesomeIcon icon="check" class="text-green-500" />
                  <span class="mx-1">{{ digitsEnToFa(showQtyProduct) }}</span>
                  <span>موجودی انبار</span>
                </div>
                <div v-else>
                  <span class="text-red-500"> در انبار موجود نیست</span>
                </div>
              </div>
           </div>

    </div>

    <!-- div for add or remove and add to basket . -->
    <div  class="hidden lg:flex items-center mb-4">
      <!-- remove btn  -->
        <button class="btn h-10 w-10 bg-red-500  text-white flex-center" @click="remove">
             <div v-if="activeBtn && quantity1.length > zz && quantity1[zz]?.qty === 1">
                <FontAwesomeIcon icon="trash" />                        
             </div>
             <div v-else-if="loading.minus">
                 <span class="inline-block  border-gray-300 h-6 w-6 animate-spin rounded-full border-4 border-t-blue-600" />
             </div>

             <div v-else>                                                  
                  <FontAwesomeIcon icon="minus"  />                           
             </div>   
        </button>

         <div class="flex flex-col items-center justify-center w-10 mt-2 h-12 ">
             <span v-if="!activeBtn" class="public-text">{{ digitsEnToFa(qty) }}</span>
             <span v-if="quantity1[zz] && activeBtn" class="public-text">{{digitsEnToFa(quantity1[zz].qty) }}</span>
             <span class="public-text1-b" :class="final ? '' : 'hidden'" >حداکثر</span >
         </div>

         <!-- add btn  -->
         <button class="btn h-10 w-10 bg-red-500 text-white  flex-center" @click="add" >
             <div v-if="loading.plus"> 
                <span class="inline-block  border-gray-300 h-6 w-6 animate-spin rounded-full border-4 border-t-blue-600" />
             </div>
             <div v-else>
                 <FontAwesomeIcon icon="plus" class="font-black" />
             </div>
         </button>

         <!-- div for basket btn  -->
            <div>
              <div  v-if="activeBtn &&  la && ba"  class="flex flex-col mx-2 public-text1-b ">
                  <span>در سبد شما</span>
                  <span >مشاهده
                      <router-link to="/cart" class="text-sky-400 hover:text-sky-500" >سبد خرید</router-link></span>
              </div>
              
              <button tyle="btn" v-else class="btn px-2 mx-2 w-44 flex-center gap-2  text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 shadow-md shadow-cyan-500/50 dark:shadow-md dark:shadow-cyan-800/80 font-medium rounded-lg text-sm  h-10  public-text2-b transition-all" @click="addToCart">
                  <span class="inline-block  border-gray-300 h-6 w-6 animate-spin rounded-full border-4 border-t-blue-600" :class="loading.addCard?'block':'hidden'" />
                  <span class="inline-block ">افزودن به سبد خرید</span>
              </button>
            </div>
    </div>

    <!-- div for error  -->
     <div v-show="cartAlert" class="h-12 min-w-72  bg-slate-700 fixed bottom-8  left-1/2 -translate-x-1/2 flex items-center justify-between p-2 public-text1-b text-white gap-2 rounded z-50">
       {{ addTocartError }}
       <FontAwesomeIcon icon="close" class="cursor-pointer hover:text-blue-400 h-4 w-4 transition-all" @click="cartAlert=false"  />
     </div>

     <!-- div for add or remove btn in phone  -->
     <div class=" fixed lg:hidden inset-x-0  h-20 bottom-0  z-40 border-t-2 border-blue-200 bg-white p-2">
          <div class="w-full h-full flex items-center gap-4">
                <!-- add or remove and add to basket  -->
                <div class="w-1/2 h-10 rounded-lg overflow-hidden">
          <!-- add or remove btn  -->
           <div class="w-full h-full flex items-center rounded-lg justify-between border-blue-200 border-2" v-if="activeBtn &&  la && ba">

           <!-- add btn  -->
              <button class="btn h-10 w-10 text-red-500  hover:text-red-700 transition-all " @click="add" >
                 <div v-if="loading.plus"> 
                    <span class="inline-block  border-gray-300 h-6 w-6 animate-spin rounded-full border-4 border-t-blue-600" />
                 </div>
                 <div v-else>
                     <FontAwesomeIcon icon="plus" class="font-black" />
                 </div>
             </button> 
              <div class="flex flex-col items-center justify-center w-10 h-12 ">
                  <span v-if="!activeBtn" class="public-text">{{ digitsEnToFa(qty) }}</span>
                  <span v-if="quantity1[zz] && activeBtn"  class="public-text">{{digitsEnToFa(quantity1[zz].qty) }}</span>
                  <span class="public-text1-b" :class="final ? '': 'hidden'" >حداکثر</span >
              </div>

       
              <!-- remove btn  -->
               <button class="btn h-10 w-10 hover:text-red-700 text-red-500  transition-all" @click="remove">
             <div v-if="activeBtn && quantity1.length > zz && quantity1[zz]?.qty === 1">
                <FontAwesomeIcon icon="trash" />                        
             </div>
             <div v-else-if="loading.minus">
                 <span class="inline-block  border-gray-300 h-6 w-6 animate-spin rounded-full border-4 border-t-blue-600" />
             </div>

             <div v-else>                                                  
                  <FontAwesomeIcon icon="minus"  />                           
             </div>   
               </button>
          </div>
            
           <!-- add to basket  -->
           <div v-else class="">
              <button tyle="btn"  class="w-full px-2 h-10 mx-2 bg-red-500 text-white rounded  hover:text-blue-100 transition-all  public-text1-b  flex-center gap-2" @click="addToCart">
                  <span class="inline-block  border-gray-300 h-6 w-6 animate-spin rounded-full border-4 border-t-blue-600" :class="loading.addCard?'block':'hidden'" />
                  <span class="inline-block ">افزودن به سبد خرید</span>
              </button>
          
             </div>
                </div>


                 <!-- price -->
                  <div class="w-1/2 h-10  flex flex-col justify-center " >
                    <!-- discount_price  -->
                    <div  v-if="discounted_price" >
                        <div class="flex gap-2 w-full justify-end">
                            <!-- diccount_price  -->
                            <div  class="flex items-center public-text1-b text-gray-600">
                               <span class="">{{ digitsEnToFa(formatNumber(discounted_price)) }}</span>
                               <span class="inline-block mx-1">تومان</span>
                            </div>
  
                             <!-- precent  -->
                             <div class="public-text1-b bg-red-500 text-white px-1 rounded-full">
                                 <span> {{ Math.floor(((priceProduct-discounted_price)*100)/priceProduct) + '%' }} </span>
                             </div>

                        </div>
                  
                        <div class="flex items-center justify-end pl-8 public-text1-b  text-gray-400 ">
                            <del v-if="priceProduct">{{ digitsEnToFa(formatNumber(priceProduct)) }}</del>
                            <!-- skeleton  -->
                            <span v-else class="shimmer-text w-12 mr-1"></span>
                        </div>


                    </div>

                    <!-- product_price  -->
                       <!-- product price  -->
                <div v-else class="flex items-center justify-end public-text1-b  text-gray-600">
                    <span v-if="priceProduct">{{ digitsEnToFa(formatNumber(priceProduct)) }}</span>
                    <!-- skeleton  -->
                    <span v-else class="shimmer-text w-12 mr-1"></span>
                    <span class="inline-block mx-1">تومان</span>
                </div>
                  </div>
                   
          </div>
          
     </div>


     <div v-if="isPhoneSize()" class="fixed -bottom-2  left-0 bg-white z-40 w-full px-4 border-2 border-sky-500 rounded-lg transition-height"
     :class="alertAddToCart ? 'max-h-64' : 'max-h-0'">
                  <div class="h-10 w-full  flex items-center justify-between border-b">
                    <p  class="public-text1-b  text-green-600  ">این کالا به سبد خرید شما اضافه شد.</p>
                    <button @click="alertAddToCart = false" class="text-gray-500  hover-text-gray-700 transition-all">
                      <FontAwesomeIcon icon="close" class="text-gray-600 " />
                    </button>
                  </div>

                  <div class="min-h-16 h-full flex items-center gap-2">
                    <div class="h-16 w-12 overflow-hidden">
                      <img :src="props.pictures" alt="product image" />
                    </div>
                    <div class="flex flex-col">
                        <p v-if="props.products" class="public-text1-b text-gray-600">{{ props.products.name }}</p>

                        <span class="public-text1-b flex items-center gap-1 text-gray-600"> رنگ :
                          <span class="text-gray-500">{{ la }}</span>
                        </span> 
                     
                        <span class="public-text1-b flex items-center gap-1 text-gray-600"> سایز :
                            <span class="text-gray-500">{{ ba }}</span>
                        </span> 
                    </div>
                   
                  </div>
                  <div class="h-10 w-full flex-center mt-4 mb-8">
                    <router-link to="/cart" class="flex-center rounded-lg public-text w-1/2 h-10 bg-red-500 text-white hover:bg-red-600 transition-all">مشاهده سبد خرید</router-link>
                  </div>
     </div>

   </div>
</template>
<script setup>
import { ref, computed, onMounted,onUnmounted, watch,defineProps,reactive} from 'vue';

import { digitsEnToFa } from "persian-tools";

import { isPhoneSize } from "@/utils/isPhoneSize";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// pinia 
import { useCartStore } from "@/store/cart";

import axios from "axios";

import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();

axios.defaults.withCredentials = true;

axios.defaults.headers.common["X-CSRFToken"] = cookies.get("csrftoken");

const cartItems=useCartStore();

// quantity1 contain {id:?,qty:?,inventory:?}
const quantity1 = computed(() => cartItems.getQuantityArray);

// define props for recive data 
const props=defineProps({products:{type:Object},pictures:{type:String}})

// activeBtn contain false or true
const activeBtn = computed(() => cartItems.getActiveBtn);

// priceProduct save product price 
const priceProduct = ref(0);

// discounted_price seve product discounte price 
const discounted_price = ref(0);

const qtyProduct=ref(0)

const qty=ref(1);

const final = ref(false);

const loading = ref({ plus: false, minus: false, addCard: false });

//product_card_id is for save id that return api
const product_card_id = ref();

// color for save colors list 
const color = reactive([]);

// size for save size list 
const size = reactive([]);

// sizsDropDown and colorDropDown access to  selectBox  color and size
const sizsDropDown = ref(null);
const colorDropDown = ref(null);

 // cartAlert && addTocartError for show alert 
 const cartAlert=ref(false);
 const addTocartError=ref('');


const sizeList = ref(false);
const sizeValue = ref("سایز را انتخاب کنید");
const ba = ref("");

const colorList = ref(false);
const colorValue = ref("رنگ را انتخاب کنید");
const colorIndex=ref(0)
const la = ref("");

const xx = ref(0);
const zz = ref(0);

 // showQty for active div that show qty product
 const showQty =ref(false);

//  showQtyProduct is for save oty product 
 const showQtyProduct=ref()

//  show alert when user add product to basket 
 const alertAddToCart=ref(false)

// closeDropdown1 and closeDropdown2 use for close color and size menu  
const closeDropdown1 = (event) => {
  if (!event || !event.target) return;

  if (colorDropDown.value && !colorDropDown.value.contains(event.target)) {
    colorList.value = false;
  }
};

const closeDropdown2 = (event) => {
  if (!event || !event.target) return;

  if (sizsDropDown.value && !sizsDropDown.value.contains(event.target)) {
    sizeList.value = false;
  }
};

// setVariable use for set color and size list 
const setVariable=async()=>{
  color.length = 0;
  size.length = 0;
  if (props.products?.variations) {
    // Set colors
    props.products.variations.forEach((e) => {
      if (!color.includes(e.color)) {
        color.push(e.color);
      }
    });

       // Set sizes
       color.forEach((item, index) => {
      if (!size[index]) size[index] = [];
      props.products.variations.forEach((e) => {
        if (e.color === item) {
          size[index].push({
            color: e.color,
            size: e.size,
            qty: e.inventory,
          });
        }
      });
    });
    
      // Default color selection
      if (color.length === 1) {
      la.value = color[0];
      colorIndex.value = 0;
    }
    
     // set price and discount_price 
      priceProduct.value = props.products.variations[0].price;

      discounted_price.value = props.products.variations[0].discounted_price;

  }
}

const formatNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،");
};

watch(() => props.products,()=>{
  setVariable();
})
watch(ba,()=>{
   
    cartItems.disableCardAddBtn();
     // arrayQuantity set array {id:?,qty:?}
     if (localStorage.getItem("cart_id")) {
       
        cartItems.arrayQuantity() //seve data in localStorage('set_item')
    }

     // zz is for hold id that card_item
     zz.value = null;
     // showQty for active div that show qty product
     showQty.value = false;
    // showQtyProduct for show we have how meny product there is
     showQtyProduct.value = 0;
     qty.value = 1;
      if (la.value !== "" && ba.value !== "") {
          showQty.value = true; //showQty active show inventory
         for (let i = 0; i < props.products.variations.length; i++) {
            if(props.products.variations[i].color === la.value && props.products.variations[i].size === ba.value) {
               showQtyProduct.value = props.products.variations[i].inventory;
             }
          }
         
         // if check cart item not empty
          if (JSON.parse(localStorage.getItem("cart_item"))) {
           
             let list = JSON.parse(localStorage.getItem("cart_item"));
             
             let item = list.filter((e) =>
               e.product.id === props.products.id &&
               e.variation.size === ba.value &&
               e.variation.color === la.value
             );
            // if check item is in cart-item
              if (item.length !== 0) {
                 if (item[0].quantity >= showQtyProduct.value) {
                   qty.value = showQtyProduct.value;
                   final.value=true;
                } else {
                     qty.value = item[0].quantity;
                    
                }
               // enableCardAddBtn et activeBtn to true
           
                 cartItems.enableCardAddBtn()
                // product_card_id is id that api set for product in order to  add or remove from cart_item
                product_card_id.value = item[0].id;
                 xx.value = item[0].id;
               } else {
                  xx.value = 0;
               }
           } 
        for (let i = 0; i < quantity1.value.length; i++) {
           if (quantity1.value[i].id === xx.value) {
               zz.value = i;
           }
         } 
      }
})

// scrollToSection use for scroll when user not selected size or color 
const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);

  if (element && isPhoneSize()) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

const addTobaskerError=()=>{

if((!la.value && !ba.value) || !la.value){
   cartAlert.value=true;
   addTocartError.value='ابتدا رنگ و سپس سایز را انتخاب کنید.'
   scrollToSection('details')
 }
 if(la.value && !ba.value){
   cartAlert.value=true;
   addTocartError.value='سایز محصول را انتخاب کنید.'
   scrollToSection('details')
 }
 setTimeout(()=>{cartAlert.value=false},3000)
}

const addToCart = async () => {
  // close alert box 
      cartAlert.value=false;
      alertAddToCart.value=false;
    if (la.value && ba.value) {
       // alert error set empty 
       cartAlert.value=false;
       addTocartError.value=''
         
         // select variations index
        //  setProductSrore.setProductFromApi();
         let variations_index;
         for (let i = 0; i < props.products.variations.length; i++) {
           if ( props.products.variations[i].color === la.value && props.products.variations[i].size === ba.value) {
             variations_index = i;
            }
          }
          
          loading.value.addCard = true;
          
          if (localStorage.getItem("cart_id")) {
            // get cart_id from localStorage and set in address and send data
            try {
              let req = await axios.post(`https://parsinekala.com/backend/api/carts/${localStorage.getItem("cart_id")}/items/`,
              {
                product_id: props.products.id,
                variation_id: props.products.variations[variations_index].id,
                quantity: qty.value,
                
              });
              await cartItems.arrayQuantity() //seve data in localStorage('set_item')
              //  product_card_id is for save id that return api
              product_card_id.value = req.data.id;
              cartItems.enableCardAddBtn();   
                for(let i=0;i<quantity1.value.length;i++){
                  if(quantity1.value[i].id===req.data.id)
                   zz.value = i;
                }
                qty.value = 1;   
                loading.value.addCard = false;
                alertAddToCart.value=true;
                 setTimeout(()=>{alertAddToCart.value=false},3000)
              } catch (e) {   
                loading.value.addCard = false;
               console.log(e);
             }
          } else {
             // get cart_id from api and set in localStorage
             try {
               let req = await axios.post("https://parsinekala.com/backend/api/carts/",{});

               let id = req.data.id;
                 localStorage.setItem("cart_id", id);
              //set card_id in address and send data
              try {
                let req1 = await axios.post(
                  `https://parsinekala.com/backend/api/carts/${id}/items/`,
                  {
                    product_id: props.products.id,
                    variation_id: props.products.variations[variations_index].id,
                    quantity: qty.value,
                 
                  }
                );
        
        await cartItems.arrayQuantity() //seve data in localStorage('set_item')

        //  product_card_id is for save id that return api
        zz.value = 0;
        product_card_id.value = req1.data.id;
      
        cartItems.enableCardAddBtn();
        qty.value = 1;
        loading.value.addCard = false;
        alertAddToCart.value=true;
        setTimeout(()=>{alertAddToCart.value=false},3000)
              } catch (e) {
        // console.log(e);
        loading.value.addCard = false;

      }
             } catch (e) {
                loading.value.addCard = false;
              // console.log(e);
             }
          }
       }
       addTobaskerError();
     };


 // add function for add qty product 
const add = async () => {
    // close alert box 
    cartAlert.value=false;
    
     if(la.value && ba.value){
        // arrayQuantity is for set new cartId and reset cartItem when cartID change by customer in localStorage
          await cartItems.arrayQuantity();
          if(activeBtn.value && !!quantity1.value[zz.value]) {
            // if  is reloaded data for update
              if(quantity1.value[zz.value].inventory !== showQtyProduct.value) {
                // setProductSrore.setProductFromApi();
                showQtyProduct.value = quantity1.value[zz.value].inventory; 
              }
              loading.value.plus = true;            
                if (showQtyProduct.value) {
                   if (quantity1.value[zz.value].qty < showQtyProduct.value) {
                    let i = quantity1.value[zz.value].qty + 1;
 
                    try {
                       await axios.patch(`https://parsinekala.com/backend/api/carts/${localStorage.getItem("cart_id")}/items/${product_card_id.value}/`,{quantity: i});    
                          if(showQtyProduct.value===i){
                            final.value=true;
                    }
                          await cartItems.arrayQuantity();
                          loading.value.plus = false;
                    } catch (e) {
                      loading.value.plus = false;
                      // console.log(e);
                    }
                    }else {
                     
                      loading.value.plus = false;}
                 }else 
                  loading.value.plus = false;
           }else {
             if(showQtyProduct.value) {
                if(qty.value < showQtyProduct.value) {
                    qty.value += 1;
                    if(showQtyProduct.value===qty.value){
                      final.value=true;
                    }
                   }
               }
           }    
  }
      addTobaskerError();

     }

 // remove function for reduce qty product 
 const remove = async() => {
      // arrayQuantity is for set new cartId and reset cartItem when cartID change by customer in localStorage
       await cartItems.arrayQuantity();

         if (activeBtn.value && quantity1.value[zz.value]) {
            // if  is reloaded data for update
              if(quantity1.value[zz.value].inventory !== showQtyProduct.value) {
                // setProductFromApi for load data
                //  setProductSrore.setProductFromApi();
                 showQtyProduct.value = quantity1.value[zz.value].inventory;
               }

              loading.value.minus = true;
              if (quantity1.value[zz.value].qty > 2) {
               let i = quantity1.value[zz.value].qty - 1;
                try {
                  await axios.patch(`https://parsinekala.com/backend/api/carts/${localStorage.getItem(
                      "cart_id"
                    )}/items/${product_card_id.value}/`, { quantity: i });
                 
                  final.value=false;
                  await cartItems.arrayQuantity();
                  loading.value.minus = false;
                } catch (e) {
                  loading.value.minus = false;
                  // console.log(e);
                }
              } else if (quantity1.value[zz.value].qty === 2) {
                let i = quantity1.value[zz.value].qty - 1;
                try {
                  await axios.patch(
                    `https://parsinekala.com/backend/api/carts/${localStorage.getItem(
                      "cart_id"
                    )}/items/${product_card_id.value}/`,
                    { quantity: i });    

                  final.value=false;

                  await cartItems.arrayQuantity();
                  loading.value.minus = false;
                } catch (e) {
                  loading.value.minus = false;
                  // console.log(e);
                }
              } else {
                try {
                   await axios.delete(
                    `https://parsinekala.com/backend/api/carts/${localStorage.getItem(
                      "cart_id")}/items/${product_card_id.value}/`);     

                  final.value=false;
                  await cartItems.arrayQuantity() //seve data in localStorage('set_item')
                  loading.value.minus = false;
                  cartItems.disableCardAddBtn();
                  qty.value = 1;
            

                } catch (e) {
                  loading.value.minus = false;
                  // console.log(e);
                }
              }
            } else {
          

              if (qty.value > 2) {
                qty.value -= 1;
                final.value=false;

              } else if (qty.value === 2) {
                qty.value -= 1;
                final.value=false;

              } else {
                qty.value = 1;
                final.value=false;

              }
            }
     }

onMounted(() => {
     
       document.addEventListener("click", closeDropdown1);
       document.addEventListener("click", closeDropdown2);
});

onUnmounted(() => {
       document.removeEventListener("click", closeDropdown1);
       document.addEventListener("click", closeDropdown2);
     
});
 
</script>
<style lang="css" scoped>
.transition-height {
  transition: max-height 0.3s ease-in-out;
  overflow: hidden;
}
</style>